import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { ModalFooter, Tabs, TabsItem } from 'telia-front-react';

import InvoiceFileStore from '../../../stores/InvoiceFileStore';
import LayoutStore from '../../../stores/LayoutStore';
import { ModalStore } from '../../../stores/ModalStore';
import { ITranslateStore } from '../../../stores/TranslateStore';
import InvoiceDetailsFooterViewStore from '../../../stores/view/InvoiceDetailsFooterViewStore';

import InvoiceDeliveryLogNotice from '../../deliverylog/InvoiceDeliveryLogNotice';
import MobileFullScreenClosableModal from '../../common/MobileFullScreenClosableModal';
import InvoiceDetailsTabsStore, { InvoiceDetailsModalTab } from '../../../stores/InvoiceDetailsTabsStore';
import InvoiceDetailsContent from './InvoiceDetailsContent';
import InvoiceDetailsHeader from './InvoiceDetailsHeader';
import InvoiceFileButtons from './InvoiceFileButtons';
import InvoiceDetailsFooter from './InvoiceDetailsFooter';
import InvoiceDetailsInterestsTable from './InvoiceDetailsInterestsTable';

interface IInvoiceDetailsProps {
  gaGroup: string;
  invoiceDetailsTabsStore?: InvoiceDetailsTabsStore;
  invoiceFileStore?: InvoiceFileStore;
  invoiceDetailsFooterViewStore?: InvoiceDetailsFooterViewStore;
  translateStore?: ITranslateStore;
  layoutStore?: LayoutStore;
  modalStore?: ModalStore;
}

@inject('invoiceDetailsTabsStore', 'invoiceFileStore', 'invoiceDetailsFooterViewStore', 'translateStore', 'layoutStore', 'modalStore')
@observer
export default class InvoiceDetailsModal extends React.Component<IInvoiceDetailsProps> {
  public componentDidMount(): void {
    this.props.invoiceFileStore.loadFileTypes();
  }

  public componentWillUnmount(): void {
    this.props.invoiceDetailsTabsStore.resetCurrentTabToDefault();
  }

  public render(): JSX.Element {
    return (
      <MobileFullScreenClosableModal gaPage={this.props.modalStore.gaPageLabel} gaGroup={this.props.gaGroup}>
        <InvoiceDetailsHeader />
        {this.invoiceDetailsTabs()}
        {this.props.invoiceDetailsFooterViewStore.showFooter && (
          <ModalFooter isSticky={true}>
            <InvoiceDetailsFooter />
          </ModalFooter>
        )}
      </MobileFullScreenClosableModal>
    );
  }

  private invoiceDetailsTabs(): JSX.Element {
    const { translate } = this.props.translateStore;
    const currentTab = this.props.invoiceDetailsTabsStore.currentTab;

    return (
      <Tabs
        currentTab={currentTab}
        onTabChange={(prevTab: InvoiceDetailsModalTab, nextTab: InvoiceDetailsModalTab) => this.props.invoiceDetailsTabsStore.setCurrentTab(nextTab)}
        border={this.props.layoutStore.isMobile ? 'top' : 'all'}
        aria-labelledby="invoice-details"
      >
        <TabsItem id="tab-invoice-lines" label={translate('shared.invoice-details-modal.tab-titles.invoice-lines')}>
          <InvoiceDetailsContent />
        </TabsItem>
        {this.props.invoiceDetailsTabsStore.showFilesTab && (
          <TabsItem id="tab-invoice-files" label={this.props.invoiceDetailsTabsStore.invoiceFilesTabTitle}>
            <InvoiceFileButtons />
          </TabsItem>
        )}
        {this.props.invoiceDetailsTabsStore.showInterestsDetailsTab && (
          <TabsItem id="tab-interests-details" label={translate('shared.invoice-details-modal.tab-interests.details')}>
            <InvoiceDetailsInterestsTable />
          </TabsItem>
        )}
        {this.props.invoiceDetailsTabsStore.showDetailsTab && (
          <TabsItem id="tab-invoice-details" label={translate('shared.invoice-details-modal.tab-titles.details')}>
            <InvoiceDeliveryLogNotice />
          </TabsItem>
        )}
      </Tabs>
    );
  }
}
